import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("rounded-md bg-white/[0.08] motion-safe:animate-pulse", className)}
      {...props}
    />
  )
}

export { Skeleton }
